import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      user: JSON.parse(localStorage.getItem('user') || 'null'),
      token: localStorage.getItem("token"),
    };
  },
  mutations,
  actions,
  getters,
  namespaced: false
};
